import React from 'react';

interface CustomContentModalProps {
    closeModal?: (action: string) => void;
    emitEvent?: (name: string, payload?: any) => void;
    children?: React.ReactNode;
}

const CustomContentModal: React.FC<CustomContentModalProps> = React.memo(({ closeModal, emitEvent, children }) => {

    return (
        <div>
            {children}
        </div>
    );
});

export default CustomContentModal;